import ArrowBack from '@mui/icons-material/ArrowBack'
import { Button, Container, Typography } from '@mui/material'
import { useLocation } from 'preact-iso'
import { api } from '../api/client'
import type { Position } from '../api/generated/Position'
import type { PositionFields } from '../api/generated/PositionFields'
import { backLink, useEvent } from '../events/EventContext'
import { emptyPosition, PositionForm } from '../positions/PositionForm'

export function PositionNew() {
  const { route } = useLocation()
  const { event } = useEvent()
  const { slug } = event
  const back = backLink(event, '/positions')

  const create = async (fields: PositionFields) => {
    const position = await api.post<Position>(`/events/${slug}/positions`, fields)
    route(`/events/${slug}/positions/${position.id}?series`, true)
  }

  return (
    <Container maxWidth="sm" sx={{ py: 2 }}>
      <Button href={back.href} startIcon={<ArrowBack />} sx={{ mb: 1 }}>
        {back.label}
      </Button>
      <Typography variant="h4" component="h1" gutterBottom>
        Nouveau poste
      </Typography>
      <PositionForm initial={emptyPosition} submitLabel="Créer le poste" onSubmit={create} />
    </Container>
  )
}
